import { render, staticRenderFns } from "./shangshi.vue?vue&type=template&id=0617c66f&scoped=true&"
import script from "./shangshi.vue?vue&type=script&lang=js&"
export * from "./shangshi.vue?vue&type=script&lang=js&"
import style0 from "./shangshi.vue?vue&type=style&index=0&id=0617c66f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617c66f",
  null
  
)

export default component.exports